import React from 'react'
import PropTypes from 'prop-types'
import { toUrlSafe } from 'utils/stringHelpers'
import ClassCard from 'components/dashboard/ClassCard'
import { TilesContainer } from 'components/dashboard/ActiveTabProgramCards/component.styles'
import CreateCourse from 'experienceComponents/CreateCourse'
import { k8V2ContentfulMappings } from 'utils/productMaps'
import CreateSmallGroup from 'experienceComponents/CreateSmallGroup'
import TierLabel from 'components/TierLabel'
import {
  ClassesContainer,
  ButtonsContainer,
  Title,
  TitleContainer,
  StyledButton,
  StyledCreateClassIcon,
  StyledAwardIcon,
  HiddenCreateCourseContainer,
  TilesContainerWrapper,
} from './component.styles'
import {
  TITLE,
  TIER_2_TITLE,
  CREATE_CLASS_BUTTON_TEXT,
  TRAINING_BUTTON_TEXT,
  TILES_CONTAINER_CLASS_NAME,
} from './constants'

const K8DigitalProgramCardV2 = ({
  classes,
  classMenuButtonRefs,
  currentProgramName,
  internalTitle,
  onClassBlur,
  onClassFocus,
  onComponentClick,
  setFocus,
  onTrainingClick,
  onTier2ResourcesClick,
  createCourseRef,
  handleCreateClassClick,
  contentfulCourses,
  createSmallGroupRef,
  handleCreateSmallGroupClick,
  tier2ResourcesLabel,
}) => {
  const tier1Classes = classes?.filter(c => c.tier === 1)
  const tier2Classes = classes?.filter(c => c.tier === 2)
  return (
    <TilesContainerWrapper>
      {/* FirstTimeClasses component - always render when showFirstTimeClasses is true */}

      <ClassesContainer>
        <TitleContainer>
          <Title>{TITLE}</Title>
          <TierLabel labelText="TIER 1" />
        </TitleContainer>
        {classes && tier1Classes.length > 0 && (
          <TilesContainer
            className={TILES_CONTAINER_CLASS_NAME}
            key={internalTitle}
          >
            {tier1Classes.map(
              (
                {
                  completeLessons,
                  contentfulID,
                  instance,
                  scoID,
                  title,
                  totalLessons,
                },
                index,
              ) => {
                const { displayTitle } =
                  k8V2ContentfulMappings?.find(course => {
                    return contentfulID === course.id
                  }) || {}
                return (
                  <ClassCard
                    dataTestId={`class-card-${toUrlSafe(title)}`}
                    displayTitle={title}
                    gradeDisplayTitle={displayTitle}
                    instance={instance}
                    key={`class-card-${title}-${index}`}
                    onBlur={onClassBlur}
                    onClick={onComponentClick}
                    onFocus={() => onClassFocus(index)}
                    program={currentProgramName}
                    ref={classMenuButtonRefs.current[index]}
                    scoID={scoID}
                    setFocus={() =>
                      setFocus(classMenuButtonRefs.current[index])
                    }
                    totalAmount={totalLessons}
                    totalComplete={completeLessons}
                  />
                )
              },
            )}
          </TilesContainer>
        )}
        <ButtonsContainer>
          <div style={{ position: 'relative' }}>
            <StyledButton onClick={handleCreateClassClick}>
              <StyledCreateClassIcon />
              {CREATE_CLASS_BUTTON_TEXT}
            </StyledButton>
            <HiddenCreateCourseContainer ref={createCourseRef}>
              <CreateCourse
                contentfulCourses={contentfulCourses}
                emptyClasses={true}
              />
            </HiddenCreateCourseContainer>
          </div>
          {onTrainingClick && (
            <StyledButton onClick={onTrainingClick}>
              <StyledAwardIcon />
              {TRAINING_BUTTON_TEXT}
            </StyledButton>
          )}
        </ButtonsContainer>
        <TitleContainer>
          <Title>{TIER_2_TITLE}</Title>
          <TierLabel labelText="TIER 2" />
        </TitleContainer>
        {classes && tier2Classes.length > 0 && (
          <TilesContainer
            className={`${TILES_CONTAINER_CLASS_NAME}-tier-2`}
            key={`${internalTitle}-tier-2`}
          >
            {tier2Classes.map(
              ({ completeLessons, contentfulID, instance, title }, index) => {
                const { displayTitle, defaultUnit } =
                  k8V2ContentfulMappings?.find(course => {
                    return contentfulID === course.id
                  }) || {}
                return (
                  <ClassCard
                    completeLessons={completeLessons}
                    dataTestId={`class-card-${toUrlSafe(title)}`}
                    defaultUnit={defaultUnit}
                    displayTitle={title}
                    gradeDisplayTitle={displayTitle}
                    instance={instance}
                    key={`class-card-${title}-${index}`}
                    onClick={onComponentClick}
                    program={currentProgramName}
                    tier={2}
                  />
                )
              },
            )}
          </TilesContainer>
        )}
        <ButtonsContainer>
          <StyledButton onClick={handleCreateSmallGroupClick}>
            <StyledCreateClassIcon />
            {'Create a Small Group'}
          </StyledButton>
          <HiddenCreateCourseContainer ref={createSmallGroupRef}>
            <CreateSmallGroup
              contentfulCourses={contentfulCourses}
              emptyClasses={true}
            />
          </HiddenCreateCourseContainer>
          {onTier2ResourcesClick && (
            <StyledButton onClick={onTier2ResourcesClick}>
              <StyledAwardIcon />
              {tier2ResourcesLabel}
            </StyledButton>
          )}
        </ButtonsContainer>
      </ClassesContainer>
    </TilesContainerWrapper>
  )
}

K8DigitalProgramCardV2.propTypes = {
  classMenuButtonRefs: PropTypes.object,
  classes: PropTypes.array,
  contentfulCourses: PropTypes.array,
  createCourseRef: PropTypes.object,
  createSmallGroupRef: PropTypes.object,
  currentProgramName: PropTypes.string,
  displayTitle: PropTypes.string,
  handleCreateClassClick: PropTypes.func,
  handleCreateSmallGroupClick: PropTypes.func,
  headerDataTestId: PropTypes.string,
  index: PropTypes.number,
  internalTitle: PropTypes.string,
  onClassBlur: PropTypes.func,
  onClassFocus: PropTypes.func,
  onComponentClick: PropTypes.func,
  onTier2ResourcesClick: PropTypes.func,
  onTrainingClick: PropTypes.func,
  programSubheader: PropTypes.string,
  setFocus: PropTypes.func,
  showFirstTimeClasses: PropTypes.bool,
  staticLinksAvailable: PropTypes.array,
  tier2ResourcesLabel: PropTypes.string,
}

export default K8DigitalProgramCardV2
